import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SIDES } from '../constants';

import { getProductId } from '~models/product';
import { actionCreators as customPizzaActions } from '~redux/CustomPizza/actions';
import { getHalfMenuableId } from '~models/customPizza';
import { baseIngredientsSelector } from '~redux/CustomPizza/selectors';

export const usePizzaByHalvesSpecialtyData = item => {
  const dispatch = useDispatch();

  const storeId = useSelector(state => state.searchStore?.currentSubsidiary?.id);
  const flattenedMenu = useSelector(state => state.home.flattenedMenu);
  const pizzaSpecialtyData = useSelector(state => state.customPizza.pizzaSpecialtyData);
  const baseIngredients = useSelector(baseIngredientsSelector);

  const halvesIds = useMemo(
    () =>
      [SIDES.LEFT, SIDES.RIGHT]
        .map(side => getProductId(item?.halves?.[side], flattenedMenu))
        .filter(productId => productId && !pizzaSpecialtyData?.[productId]),
    [flattenedMenu, getHalfMenuableId(item, SIDES.LEFT), getHalfMenuableId(item, SIDES.RIGHT)]
  );

  useEffect(() => {
    dispatch(customPizzaActions.getPizzaSpecialtyData({ pizzaIds: halvesIds, storeId }));
  }, [storeId, halvesIds]);

  return { pizzaSpecialtyData, baseIngredients };
};
